<template>
  <div
    class="mat12"
    :class="{mobile_col_flex:!$store.getters.tagsView}"
    v-if="!$store.getters.tagsView"
  >
    <slot name="download"></slot>
    <div class="mobile_model">
      <!-- 遮罩层 -->
      <drawer-bg-mask :iSmobileSearch="iSmobileSearch" @handleCloseSearch="handleCloseSearch"></drawer-bg-mask>
      <!-- 显示高级搜索 -->
      <div style="display:flex;align-items: center;justify-content: space-between;width: 100%;">
        <div class="mobile_g_search" @click="handleOpenSearch">高级搜索>></div>
        <TotaListNum :total="total" :str="name" :unit="unit" v-if="totalNum"></TotaListNum>
        <!-- 复制考勤显示 -->
        <slot name="copy" ></slot>
      </div>
      <slot v-if="iSmobileSearch" name="search" class="mobile_model_list"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileColFlex",
  props: {
    name: {
      type: String,
      default: ""
    },
    unit: {
      type: String,
      default: "个"
    },
    total: {
      type: Number || String,
      default: 0
    },
    totalNum:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      iSmobileSearch: false
    };
  },
  methods: {
    handleCloseSearch() {
      this.iSmobileSearch = false;
    },
    handleOpenSearch() {
      this.iSmobileSearch = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.mobile_col_flex {
  display: flex;
  align-items: center;
}
.mobile_g_search {
  margin-left: 20px;
  color: #409eff;
  font-size: 14px;
  cursor: pointer;
}
</style>